var React = require('react');

function MicOn (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8,10.1c1.4,0,2.5-1.1,2.5-2.5l0-5.1C10.5,1.1,9.4,0,8,0S5.5,1.1,5.5,2.5v5.1C5.5,9,6.6,10.1,8,10.1z M12.5,7.6\n\tc0,2.5-2.1,4.3-4.5,4.3s-4.5-1.8-4.5-4.3H2.1c0,2.9,2.3,5.2,5.1,5.7V16h1.7v-2.8c2.8-0.4,5.1-2.8,5.1-5.7H12.5z"}));
}

MicOn.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = MicOn;

MicOn.default = MicOn;
